import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { MaintenanceMixture } from '../../../recommendations/types';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';
import { toApiError } from '../utils';

export interface ConfirmMixturesFilter {
	period: string;
	dateFrom?: string;
	dateTo?: string;
	sectorIds?: string[];
}

export type ConfirmMixturesSelection = { mixtureIds: string[] } | ConfirmMixturesFilter;

export type ConfirmMixturesPayload = { planId: string } & ConfirmMixturesSelection;

export function usePostConfirmMixtures() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation<{ mixtures: MaintenanceMixture[] }, Error, ConfirmMixturesPayload>({
		mutationFn: async (payload) => {
			try {
				const { data } = await api.post<{ mixtures: MaintenanceMixture[] }>(
					'/advices/fertilization-plan/mixtures/confirm',
					payload,
					{ params: { forBinding } }
				);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao confirmar as misturas');
			}
		},
		onSettled: (_data, _error, variables) =>
			queryClient.invalidateQueries({ queryKey: ['maintenance', variables.planId] }),
	});
}
